/**
 * AI agent settings API client (BFF: `/api/v1/store/settings/ai-agents`).
 *
 * AI assistants plus the model-provider connection test (→ web-ai-agent-service).
 * The provider secret is write-only on update.
 */
import { apiClient } from '@/shared/api';
import type {
  AiAgentSettings,
  TestConnectionResult,
  UpdateAiAgentSettingsRequest,
} from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/ai-agents';

export const getAiAgentSettings = async (): Promise<AiAgentSettings> =>
  (await apiClient.get<AiAgentSettings>(BASE)).data;

export const updateAiAgentSettings = async (
  body: UpdateAiAgentSettingsRequest,
): Promise<AiAgentSettings> => (await apiClient.put<AiAgentSettings>(BASE, body)).data;

export const testAiAgentProviderConnection = async (): Promise<TestConnectionResult> =>
  (await apiClient.post<TestConnectionResult>(`${BASE}/provider/test-connection`)).data;
